export default "__VITE_PUBLIC_ASSET__0b196c4e__"